import React from 'react';
import propTypes from 'prop-types';
import moment from 'moment';
import { DatePicker } from '@tcc/crate';
import { getMessage } from 'util/locale';

const PlannedApplicationDate = ({
  onSelectDate,
  selectedDate
}) => {
  const selectedParsed = selectedDate
    ? moment.utc(selectedDate).format('YYYY-MM-DD') : selectedDate;

  return (
    <div className="planned-application-date">
      <DatePicker
        label={getMessage('title-text__application-date')}
        maxDate={moment().add(1,'years').toISOString()}
        minDate={moment().subtract(1,'years').toISOString()}
        moment={moment}
        onChangeDate={onSelectDate}
        selected={selectedParsed}
        testId="experiment-date"
      />
    </div>
  );
};

PlannedApplicationDate.propTypes = {
  onSelectDate: propTypes.func,
  selectedDate: propTypes.string
};

export default PlannedApplicationDate;
